/**
 * System update API helpers (F-115 / T-014).
 *
 * Hand-rolled fetch (not the generated gateway client) because the
 * /system/updates routes post-date the committed OpenAPI snapshot.
 * Swap to generated methods after the next `npm run gen:api:gateway`.
 */

export interface SystemUpdateStatus {
  available: boolean;
  current_version: string | null;
  latest_version: string | null;
  changelog: string | null;
  check_failed: boolean;
}

export interface ApplyResult {
  status: string;
}

function getGatewayBase(): string {
  const env = (import.meta as ImportMeta).env as Record<string, string | undefined> | undefined;
  return (env?.["VITE_GATEWAY_BASE_URL"] ?? "http://localhost:8200").replace(/\/$/, "");
}

async function getToken(): Promise<string | null> {
  try {
    const { useAuth } = await import("./auth-store");
    return useAuth.getState().getActiveJwt();
  } catch {
    return null;
  }
}

export async function fetchSystemUpdates(): Promise<SystemUpdateStatus> {
  const base = getGatewayBase();
  const token = await getToken();
  const resp = await fetch(`${base}/api/mirlai/v1/system/updates`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!resp.ok) {
    throw new Error(`System updates check failed: ${resp.status}`);
  }
  return resp.json() as Promise<SystemUpdateStatus>;
}

export async function applySystemUpdate(): Promise<ApplyResult> {
  const base = getGatewayBase();
  const token = await getToken();
  const resp = await fetch(`${base}/api/mirlai/v1/system/updates/apply`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!resp.ok) {
    throw new Error(`System update apply failed: ${resp.status}`);
  }
  return resp.json() as Promise<ApplyResult>;
}
